import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../../../app.config';
import { MessageService } from 'primeng/api';
import { RegistrationService } from '../../../../services/registration.service';
import {Router} from "@angular/router";

@Component({
  selector: 'app-wizard-shop-profile',
  templateUrl: './wizard-shop-profile.component.html',
  styleUrls: ['./wizard-shop-profile.component.scss'],
})
export class WizardShopProfileComponent implements OnInit {
  @Input() messageService: MessageService;
  @Input() partner;
  @Input() verificationCode;
  @Output() next = new EventEmitter();
  public ShopProfileForm: FormGroup;
  public loading = true;
  public saving = false;
  public message = null;
  public POSSytems = [];
  public POSSystemID = -1;
  public onlyRentals: boolean = false;
  public creatingDummyData: boolean = false;
  constructor(
    private appConfig: AppConfig,
    private fb: FormBuilder,
    private translate: TranslateService,
    private registrationService: RegistrationService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.POSSytems = this.appConfig.getSupportedPOSSystems();
    if (!this.partner || !this.partner.PartnerID) {
      this.registrationService.verifyAccount(this.verificationCode).subscribe(
        (partner) => {
          this.partner = partner;

          if (
            this.partner.SubscribedProducts &&
            this.partner.SubscribedProducts.length === 1 &&
            this.partner.SubscribedProducts.filter((x) => {
              return x.productType === 'RENTALS';
            }).length > 0
          ) {
            this.onlyRentals = true;
            this.POSSytems = this.appConfig.getSupportedRentalPOSSystems();
          }

          this.setupValidation();
          this.loading = false;
        },
        (err) => {
          this.message = this.translate.instant(
            'onboarding.messages.verification_failed',
          );
          this.loading = false;
        },
      );
    } else {
      if (
        this.partner.SubscribedProducts &&
        this.partner.SubscribedProducts.length === 1 &&
        this.partner.SubscribedProducts.filter((x) => {
          return x.productType === 'RENTALS';
        }).length > 0
      ) {
        this.onlyRentals = true;
        this.POSSytems = this.appConfig.getSupportedRentalPOSSystems();
      }

      this.setupValidation();
      this.loading = false;
    }
  }

  setupValidation() {
    this.ShopProfileForm = new FormGroup({
      Email: new FormControl(this.partner.UserName || '', [
        Validators.required,
        Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
      ]),
      PhoneNumber1: new FormControl(
        this.partner.Phone || '',
        Validators.required,
      ),
      MinimumJobcardNo: new FormControl(this.partner.MinimumJobcardNo || 100, [
        Validators.required,
        Validators.pattern('^[+0-9]+$'),
      ]),
      OffersBookingService: new FormControl(
        this.partner.OffersBookingService || (this.onlyRentals ? false : true),
        Validators.required,
      ),
      PhysicalAddress: new FormControl(
        this.partner.PhysicalAddress || '',
        Validators.required,
      ),
      WebAddress: new FormControl(
        this.partner.WebAddress || '',
        Validators.required,
      ),
      POSSystemID: new FormControl(
        this.partner.POSSystemID > -1 ? this.partner.POSSystemID : 0,
        Validators.nullValidator,
      ),
    });
    if (this.partner.POSSystemID > -1) {
      this.POSSystemID = this.partner.POSSystemID;
    }
    if (this.ShopProfileForm.value.PhysicalAddress === '') {
      this.ShopProfileForm.controls['PhysicalAddress'].markAsDirty();
    }
    if (this.ShopProfileForm.value.WebAddress === '') {
      this.ShopProfileForm.controls['WebAddress'].markAsDirty();
    }
  }

  setPOSSystemID(ID) {
    this.POSSystemID = ID;
    this.ShopProfileForm.controls['POSSystemID'].setValue(ID);
  }

  saveProfile() {
    this.saving = true;
    var data = {
      ...this.partner,
      ...this.ShopProfileForm.value,
    };

    this.registrationService
      .updateBikeShop(this.verificationCode, data)
      .subscribe(
        (partner) => {
         // this.next.emit(data);
          this.saving = false;
          this.skipToHubtiger()
        },
        (err) => {
          this.saving = false;
        },
      );
  }

  skipToHubtiger() {
    this.creatingDummyData = true;
    this.registrationService.generateDummyData(this.verificationCode, { PartnerID: this.partner.PartnerID }).subscribe(result => {
      this.creatingDummyData = false;
      this.router.navigateByUrl("/store/calendar");
    }, err => {
      this.creatingDummyData = false;
      this.router.navigateByUrl("/store/calendar");
    });

  }
}
